var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{on:{"click":_vm.goWxApp}},[_vm._v("点击跳转")])])
}
var staticRenderFns = []

export { render, staticRenderFns }